export const T = {
  en_GB: {
    firstDataPoint: "First",
    lastDataPoint: "Last",
    lastSync: "Synced",
    currency: "Currency",
    dataPoints: "Data Points",
    loading: "Loading chart data...",
    noData: "No data points stored for this instrument.",
    chart: "Chart",
    statistics: "Statistics",
    monthlyPoints: "Monthly Points",
    lastPrice: "Last Price",
    loadingStatistics: "Loading statistics...",
    noStatistics: "No statistics available for this instrument.",
  },
  nb_NO: {
    firstDataPoint: "Første",
    lastDataPoint: "Siste",
    lastSync: "Synket",
    currency: "Valuta",
    dataPoints: "Datapunkter",
    loading: "Laster diagramdata...",
    noData: "Ingen datapunkter lagret for dette instrumentet.",
    chart: "Diagram",
    statistics: "Statistikk",
    monthlyPoints: "Månedlige punkter",
    lastPrice: "Siste pris",
    loadingStatistics: "Laster statistikk...",
    noStatistics: "Ingen statistikk tilgjengelig for dette instrumentet.",
  },
} as const;
